<div class="ir-item-line th-filter">
  <div (click)="setOrderBy('etag')" class="ir-item-cell s2 clickable">
    <span>
      <i class="material-icons" *ngIf="direction === 'asc'">arrow_drop_up</i>
      <i class="material-icons" *ngIf="direction === 'desc'">arrow_drop_down</i>
      {{ 'templates.last-modified-date' | translate }}
    </span>
  </div>
  <div (click)="setOrderBy('name')" class="ir-item-cell s2 clickable active">
    <span>
      <i class="material-icons" *ngIf="direction === 'asc'">arrow_drop_up</i>
      <i class="material-icons" *ngIf="direction === 'desc'">arrow_drop_down</i>
      {{ 'common.name' | translate }}
    </span>
  </div>
  <div (click)="setOrderBy('applicationSubType')" class="ir-item-cell s2 clickable">
    <span>
      <i class="material-icons" *ngIf="direction === 'asc'">arrow_drop_up</i>
      <i class="material-icons" *ngIf="direction === 'desc'">arrow_drop_down</i>
      {{ 'inspection.sub-type' | translate }}
    </span>
  </div>
  <div (click)="setOrderBy('productLineId')" class="ir-item-cell s2 clickable">
    <span>
      <i class="material-icons" *ngIf="direction === 'asc'">arrow_drop_up</i>
      <i class="material-icons" *ngIf="direction === 'desc'">arrow_drop_down</i>
      {{ 'templates.product-line' | translate }}
    </span>
  </div>
  <div (click)="setOrderBy('status')" class="ir-item-cell s2 clickable">
    <span>
      <i class="material-icons" *ngIf="direction === 'asc'">arrow_drop_up</i>
      <i class="material-icons" *ngIf="direction === 'desc'">arrow_drop_down</i>
      {{ 'common.status' | translate }}
    </span>
  </div>
</div>
<div class="ir-content-flow has-filter has-actions" [class.has-footer]="footer">
  <div class="ir-section--list">
    <div
      class="ir-item-line th-inspection clickable"
      [class.indent]="selectable"
      (click)="selectInspectionModel(model)"
      *ngFor="let model of models | orderBy : orderByFieldName : direction | searchBy : query"
    >
      <div class="ir-item-cell s2">
        <div class="ir-item-selector" *ngIf="selectable">
          <i class="material-icons" *ngIf="!model.selected">check_box_outline_blank</i>
          <i class="material-icons" *ngIf="model.selected">check_box</i>
        </div>
        <span>{{ model?.etag | formatDate }}</span>
      </div>
      <div class="ir-item-cell s2">
        <span>{{ model?.name }}</span>
      </div>
      <div class="ir-item-cell s2">
        <span>{{
          (model?.applicationSubType ? 'application.sub-type.' + applicationSubType[model.applicationSubType] : '')
            | translate
        }}</span>
      </div>
      <div class="ir-item-cell s2 important">
        <span>{{ model?.getProductLineId() | productline | async }}</span>
      </div>
      <div class="ir-item-cell s2 important">
        <span>{{ model?.status | inspectionstatus }}</span>
      </div>
    </div>
    <div class="ir-item-empty ir-mv8" *ngIf="models?.length == 0">
      <p>
        <span>{{ 'templates.no-model' | translate }}</span>
      </p>
    </div>
  </div>
</div>
